import React from "react";
import { Link } from "@reach/router";
import { withRouteData } from "react-static";
import Helmet from "react-helmet";
import { compose } from "recompose";

import withTracker from "../utils/withTracker";

import AppInfo from "../components/AppInfo";
import BeachText from "../components/BeachText";
import Waves from "../components/Waves";
import Carousel from "../components/Carousel/Carousel";
import Slide from "../components/Carousel/Slide";
import HomeHero from "../components/HomeHero";
import HomeCards from "../components/HomeCards";
import QuickSchedule from "../components/QuickSchedule";
import Alerts from "../components/Alerts";
import Navigation from "../components/Navigation";

// import mTicketSplash from '../assets/img/mtix-mockup.jpg';
// import maskSplash from '../assets/img/mask.jpg';
import ShopInfo from "../components/ShopInfo";

const largeH1 = "calc(30px + (50 - 30) * ((100vw - 300px) / (1600 - 300)))";
const largeH2 = "calc(15px + (25 - 15) * ((100vw - 300px) / (1600 - 300)))";

export default compose(withRouteData)(({ scheduleCalendar, posts, events }) => (
  <div>
    <Helmet
      title="Fire Island Ferries"
      meta={[
        {
          name: "description",
          content:
            "Fire Island Ferries provides ferry service between Bay Shore, NY and Kismet, Saltaire, Fair Harbor, Dunewood, Atlantique, Ocean Beach, Seaview, and Ocean Bay Park on Fire Island.  Visit our site for updates, service notifications, and new schedules.",
        },
        {
          name: "keywords",
          content: "Fire Island Ferries, Water Taxi, notifications, updates",
        },
        {
          name: "robots",
          content: "nosnippet",
        },
      ]}
    />
    <Navigation />
    <HomeHero />
    <div className="wave-schedule">
      <div className="wave-index shadowed-alpha">
        <Waves>
          <HomeCards />
          {/* <QuickSchedule calendar={scheduleCalendar} /> */}</Waves>
      </div>
    </div>
    <div style={{ backgroundColor: "white" }}>
      {posts && posts.length > 0 && <Alerts posts={posts} />}
    </div>
    {/* <div>
      <section id="alerts">
        <div className="container">
          <div className="row h-100">
            <div className={`fiapi col-md post-info`}>
              <h3>Freight Update</h3>
              <h2>
                <Link to="info/freight/ldw">
                  2023 Labor Day Weekend Freight Info
                </Link>
              </h2>
              <p className="timestamp">Posted on: August 19, 2023</p>
              <p>
                Please review our special information and freight house hours
                for Labor Day Weekend 2023.{' '}
              </p>
              <Link
                className={`btn btn-outline-primary align-bottom stretched-link`}
                to="info/freight/ldw"
              >
                More Info
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div> */}
    <div style={{ textAlign: "center" }}>
      <AppInfo />
    </div>
    <div style={{ textAlign: "center" }}>
      <ShopInfo />
    </div>
  </div>
));
